import { FeatureKey } from 'common/constants/permission'
import { PageParams } from 'common/types/api'

import { PeriodOfDay } from '../constants'

export interface WaterRequestVariables {
  cycleId: string
  params: {
    date: string
  } & PageParams
}

export interface WaterQuality {
  id: number
  date: string
  timeOfDay: PeriodOfDay
  salinity: number
  pH: number
  temperature: number
  DO: number
  alkali: number
  nitrite: number
  ammonia: number
  terbidity: number
  cycleId: string
  shrimpAge: number
}

export interface WaterQualityValue {
  salinity: number
  pH: number
  temperature: number
  DO: number
  alkali: number
  nitrite: number
  ammonia: number
  terbidity: number
}

export interface WaterQualityChart {
  shrimpAge: number
  timeOfDay: PeriodOfDay
  pH: number
  salinity: number
  temperature: number
  DO: number
  alkali: number
  nitrite: number
  ammonia: number
  terbidity: number
}

export interface MeasurementTimes {
  timeOfDay: PeriodOfDay
  waterQualityValues: WaterQualityValue
}

export interface CreateWaterQualityVariables {
  body: {
    date: string
    measurementTimes: MeasurementTimes[]
  }
}

export interface RecordWaterQualityResponse {
  date: string
  measurementTimes: MeasurementTimes[]
}

export interface CreateWaterMineralVariables {
  body: {
    date: string
    calcium: number
    magnesium: number
    potassium: number
  }
}

export type DisplayMode = 'card' | 'table'

export interface WaterMineral {
  id: number
  date: string
  calcium: number
  magnesium: number
  potassium: number
  cycleId: string
  createdBy: string
  shrimpAge: number
}

export interface WaterMineralChart {
  shrimpAge: number
  calcium: number
  magnesium: number
  potassium: number
}

export interface Vibrio {
  id: number
  date: string
  greenVibrio: number
  yellowVibrio: number
  cycleId: string
  createdBy: string
  shrimpAge: number
}

export interface VibrioChart {
  shrimpAge: number
  greenVibrio: number
  yellowVibrio: number
}

export interface WaterBacteriaVariables {
  cycleId: string
  params: {
    date: string
  } & PageParams
}

export interface CreateWaterBacteriaVariables {
  body: {
    date: string
    greenVibrio: number
    yellowVibrio: number
  }
}

export interface QualityTableRow {
  date: string
  salinityMorning: string
  salinityEvening: string
  pHMorning: string
  pHEvening: string
  temperatureMorning: string
  temperatureEvening: string
  DOMorning: string
  DOEvening: string
  alkaliMorning: string
  alkaliEvening: string
  nitriteMorning: string
  nitriteEvening: string
  ammoniaMorning: string
  ammoniaEvening: string
  terbidityMorning: string
  terbidityEvening: string
  shrimpAge: number
}

export interface EditWaterMineralVariables {
  mineralId: number
  body: {
    date: string
    calcium: number
    magnesium: number
    potassium: number
  }
}

export interface EditWaterVibrioVariables {
  vibrioId: number
  body: {
    date: string
    greenVibrio: number
    yellowVibrio: number
  }
}

export interface DeleteWaterQualityVariables {
  params: {
    date: string
  }
}

export interface WaterQualityRecord {
  pH: number | null
  salinity: number | null
  temperature: number | null
  DO: number | null
  alkali: number | null
  nitrite: number | null
  ammonia: number | null
  terbidity: number | null
}

export interface WaterQualityToday {
  morning: WaterQualityRecord
  evening: WaterQualityRecord
}

export type WaterTableFilter =
  | FeatureKey.WaterQuality
  | FeatureKey.WaterMineral
  | FeatureKey.WaterVibrio

export type WaterEditData = QualityTableRow | WaterMineral | Vibrio

export function isWaterMineral(obj: any): obj is WaterMineral {
  return (
    typeof obj === 'object' &&
    'id' in obj &&
    'date' in obj &&
    'calcium' in obj &&
    'magnesium' in obj &&
    'potassium' in obj &&
    'cycleId' in obj &&
    'createdBy' in obj &&
    'createdAt' in obj &&
    'updatedAt' in obj &&
    'shrimpAge' in obj
  )
}

export function isWaterQuality(obj: any): obj is WaterQuality {
  return (
    typeof obj === 'object' &&
    'id' in obj &&
    'date' in obj &&
    'timeOfDay' in obj &&
    'salinity' in obj &&
    'pH' in obj &&
    'temperature' in obj &&
    'DO' in obj &&
    'alkali' in obj &&
    'nitrite' in obj &&
    'ammonia' in obj &&
    'terbidity' in obj &&
    'cycleId' in obj &&
    'shrimpAge' in obj
  )
}

export function isWaterVibrio(obj: any): obj is Vibrio {
  return (
    typeof obj === 'object' &&
    'id' in obj &&
    'date' in obj &&
    'greenVibrio' in obj &&
    'yellowVibrio' in obj &&
    'cycleId' in obj &&
    'createdBy' in obj &&
    'createdAt' in obj &&
    'updatedAt' in obj &&
    'shrimpAge' in obj
  )
}
